/**
 * REEMPLAZA: frontend/src/components/UI.js
 * Agrega: link a perfil, créditos en navbar, mejor Btn component
 */
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState, useEffect } from "react";
import { apiFetch } from "../api";

export const C = {
  bg:"#0d0d0f", surface:"#111115", surface2:"#16161c",
  border:"#1e1e26", accent:"#f0ec57", text:"#e8e6e1",
  muted:"#555", error:"#ff6b6b", success:"#57f0a0", warn:"#ffa94d",
};

export function Btn({ children, onClick, type="button", loading, variant="primary", small, style={} }) {
  const styles = {
    primary:  { background:C.accent, color:"#0d0d0f", border:"none" },
    ghost:    { background:"transparent", color:C.muted, border:`1px solid ${C.border}` },
    danger:   { background:"transparent", color:C.error, border:`1px solid ${C.error}33` },
    success:  { background:"#0a3a1a", color:C.success, border:`1px solid ${C.success}44` },
  };
  return (
    <button type={type} onClick={onClick} disabled={loading}
      style={{ ...styles[variant], borderRadius:"7px", fontWeight:600, cursor:loading?"wait":"pointer",
        padding: small ? "5px 12px" : "8px 18px",
        fontSize: small ? "0.75rem" : "0.83rem",
        opacity: loading ? 0.6 : 1, transition:"opacity 0.15s",
        fontFamily:"inherit", ...style }}>
      {loading ? "…" : children}
    </button>
  );
}

export function StatusDot({ status }) {
  const colors = { running:C.success, stopped:"#333", starting:C.warn };
  return <span style={{ width:7, height:7, borderRadius:"50%", background:colors[status]||"#333", display:"inline-block" }} />;
}

export function Input({ label, value, onChange, type="text", placeholder }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
      {label && <label style={{ fontSize:"0.72rem", color:C.muted, textTransform:"uppercase", letterSpacing:"0.08em" }}>{label}</label>}
      <input type={type} value={value} onChange={onChange} placeholder={placeholder}
        style={{ background:"#1a1a22", border:`1px solid ${C.border}`, color:C.text,
          borderRadius:"7px", padding:"9px 13px", fontSize:"0.88rem", width:"100%" }} />
    </div>
  );
}

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    if (user) {
      apiFetch("/credits/balance").then(b => setCredits(b.credits)).catch(() => {});
    }
  }, [user]);

  return (
    <nav style={{ display:"flex", alignItems:"center", gap:"1rem", padding:"0 1.25rem",
      height:"48px", background:C.surface, borderBottom:`1px solid ${C.border}`, flexShrink:0 }}>
      <Link to="/" style={{ fontWeight:800, fontSize:"1rem", color:C.accent,
        textDecoration:"none", letterSpacing:"-0.03em" }}>{"</> CodePad"}</Link>
      <div style={{ flex:1 }} />
      {user ? (
        <>
          <Link to="/dashboard" style={{ color:C.muted, textDecoration:"none", fontSize:"0.82rem" }}>Dashboard</Link>
          {user.is_admin && (
            <Link to="/admin" style={{ color:C.accent, textDecoration:"none", fontSize:"0.82rem", fontWeight:600 }}>⚙️ Admin</Link>
          )}
          <Link to="/profile" style={{ display:"flex", alignItems:"center", gap:"6px",
            color:C.muted, textDecoration:"none", fontSize:"0.82rem" }}>
            {credits !== null && (
              <span style={{ background:"#1a1a00", border:`1px solid ${C.accent}33`,
                color:C.accent, borderRadius:"4px", padding:"2px 8px", fontSize:"0.72rem", fontWeight:600 }}>
                {credits} cr
              </span>
            )}
            👤 Perfil
          </Link>
          <button onClick={() => { logout(); nav("/"); }}
            style={{ background:"none", border:`1px solid ${C.border}`, color:C.muted,
              borderRadius:"6px", padding:"4px 12px", fontSize:"0.78rem", cursor:"pointer", fontFamily:"inherit" }}>
            Salir
          </button>
        </>
      ) : (
        <Link to="/login" style={{ background:C.accent, color:"#0d0d0f", borderRadius:"6px",
          padding:"5px 14px", fontWeight:700, fontSize:"0.8rem", textDecoration:"none" }}>Login</Link>
      )}
    </nav>
  );
}
